import styled, { css } from 'styled-components'

import type { Width } from '../../../themes'
import { Text } from '../../core'
import { Stack } from '../../layout'
import { StyledCard } from '../../surfaces/Card/Card.styles'
import { InputContainer } from '../Input/Input.styles'

export const RecentQueriesTitle = styled(Text)`
  display: flex;
  padding: ${props => props.theme.spacings.medium};
  background-color: ${props => props.theme.colors.neutral.lighter};
`

export const StackContainer = styled(Stack)<{ fluid: boolean; width: Width }>`
  position: relative;
  &,
  input,
  ${InputContainer}, ${StyledCard} {
    width: ${props => (props.fluid ? '100%' : props.width)};
  }
`

export const SearchBarContainer = styled.div`
  position: relative;
`

// When portaled, positioning (position/top/left/width/z-index) is handled entirely by the
// wrapper div Popper controls in Searchbar.tsx -- this stays unstyled in that case.
export const SearchbarMenu = styled.div<{ portaled?: boolean }>`
  ${props =>
    !props.portaled &&
    css`
      margin-top: ${props.theme.spacings.small};
      position: absolute;
      width: 100%;
      z-index: 100;
    `}
`
